export default __webpack_public_path__ + "static/media/117.8ee80685.gif";